<template>
  <v-data-table
    :value="value"
    :headers="headers"
    :items="items"
    :single-select="singleSelect"
    :item-key="itemKey"
    :show-select="showSelect"
    class="elevation-1"
    :hide-default-footer="hideDefaultFooter"
    hide-default-divider
    :loading="loading"
    loading-text="Cargando información..."
    :style="{ borderRadius: borderRadius }"
    :height="height"
    :fixed-header="fixedHeader"
    :items-per-page="itemsPerPage"
    @input="(value) => $emit('input', value)"
  >
    <template v-slot:top v-if="title">
      <GenericTitle
        class="text-center pt-7 pb-3"
        :title="title"
        font-size="16px"
        :font-weight="600"
      />
    </template>
    <template v-slot:[`item.statusName`]="{ item }">
      <div class="status-item__container">
        <div
          class="status-item__circle"
          :style="{ color: getColor(item) }"
        ></div>
        <span class="ml-2">{{ item.statusName }}</span>
      </div>
    </template>
    <template v-if="actions.length > 0" v-slot:[`item.actions`]="{ item }">
      <v-icon
        v-if="actions.includes('delete')"
        small
        @click="() => $emit('deleteAction', item)"
        color="#FF0000"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import GenericTitle from '../../common/titles/GenericTitle';
export default {
  name: 'DataTable',
  props: {
    title: { type: String, default: null },
    value: { type: Array, default: () => [] },
    headers: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    actions: { type: Array, default: () => [] },
    borderRadius: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    itemKey: { type: String, default: '' },
    showSelect: { type: Boolean, default: false },
    height: { type: Number, default: 250 },
    fixedHeader: { type: Boolean, default: false },
    hideDefaultFooter: { type: Boolean, default: true },
    itemsPerPage: { type: Number, default: 50 },
  },
  components: {
    GenericTitle,
  },
  data: () => ({
    singleSelect: true,
  }),
  methods: {
    getColor({ statusName }) {
      switch (statusName) {
        case 'Pendiente':
          return '#FFE24B';
        default:
          return '#000';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}
.status-item {
  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__circle {
    border-radius: 50%;
    border: 5px solid;
  }
}
</style>
